
<!--
~ VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as published by
~ the Free Software Foundation, version 3 of the License.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. Look for COPYING file in the top folder.
~ If not, see http://www.gnu.org/licenses/.
-->

@if (onMainView) {
  <div id="assign_project_option" class="option-icon" [class.selected]="value || isVisible" (click)="onOpen.emit(id)">
    <mat-icon>work</mat-icon>
    <p>{{ 'ASSIGN_PROJECT' | translate }}</p>
  </div>
}

@if (active) {
  <div id="assign_project_option_list" class="option-list">
    <mat-list role="list">
      @for (project of filteredItems; track project; let i = $index) {
        <mat-list-item role="listitem"
          [class.selected]="i == selectedIndex"
          (click)="onItemClick(project)">
          <mat-icon>work</mat-icon>
          <span>{{project.name}}</span>
        </mat-list-item>
      }
    </mat-list>
  </div>
}
